import { Box, Drawer, type DrawerProps } from "@mui/material";

interface IFormDrawerProps extends DrawerProps {
  fullWidth?: boolean;
}

export const FormDrawer = (props: IFormDrawerProps) => {
  const { children, fullWidth, ...rest } = props;
  return (
    <Drawer
      onClose={() => {}}
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 2,
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: fullWidth ? "100%" : 580,
          [theme.breakpoints.down("sm")]: {
            width: "100%",
          },
        },
      })}
      aria-hidden={false}
      aria-modal="true"
      {...rest}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};
